import { type ReactNode } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'

interface Project {
  id: string
  name: string
  slug: string
  role: string
}

interface MainLayoutProps {
  children: ReactNode
  activeView: string
  onViewChange: (view: string) => void
  currentProject?: Project | null
  onSwitchProject?: () => void
}

const viewTitles: Record<string, string> = {
  discovery: 'Discovery Workflow',
  'discovery-assistant': 'AI Discovery Coach',
  interviewer: 'Interview Analysis',
  sources: 'Document Analyzer',
  crm: 'Customers & Contacts',
  ontology: 'Ontology Explorer',
  schema: 'Schema Browser',
  graph: 'Graph Explorer',
  tree: 'Data Tree',
  canvas: 'Business Model Canvas',
  instances: 'Instances',
  query: 'SPARQL Query',
  pdf: 'Documents',
  reports: 'Reports',
  settings: 'Settings',
  'ai-workflows': 'AI Workflows & Prompts',
  help: 'Help & Documentation',
}

export function MainLayout({
  children,
  activeView,
  onViewChange,
  currentProject,
  onSwitchProject,
}: MainLayoutProps) {
  const title = viewTitles[activeView] || ''

  return (
    <div className="h-full w-full flex overflow-hidden shadow-xl rounded-2xl">
      <Sidebar
        activeView={activeView}
        onViewChange={onViewChange}
        currentProject={currentProject}
        onSwitchProject={onSwitchProject}
      />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0 bg-background rounded-r-2xl">
        <Header title={title} />
        <div className="flex-1 flex flex-col min-h-0 px-8 pb-8">
          <main className="flex-1 min-h-0 overflow-hidden">
            {children}
          </main>
        </div>
      </div>
    </div>
  )
}
